import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Docs20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.76923 1.8L9 4.19645L15.2308 1.8C15.7137 1.61425 16.25 1.98257 16.25 2.50001V6.00001C16.25 6.41422 15.9142 6.75001 15.5 6.75001C15.0858 6.75001 14.75 6.41422 14.75 6.00001V3.59203L9.26923 5.70002C9.09593 5.76667 8.90407 5.76667 8.73077 5.70002L3.25 3.59203V13.4849L9.26923 15.8C9.65584 15.9487 9.8487 16.3826 9.70001 16.7692C9.55132 17.1558 9.11737 17.3487 8.73077 17.2L2.23077 14.7C1.94112 14.5886 1.75 14.3103 1.75 14V2.50001C1.75 1.98257 2.28629 1.61425 2.76923 1.8Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.75 11.5C8.75 9.1528 10.6528 7.25001 13 7.25001C15.3472 7.25001 17.25 9.1528 17.25 11.5C17.25 12.5308 16.883 13.476 16.2725 14.2118L18.5304 16.4697L17.4697 17.5303L15.1224 15.183C14.4978 15.5436 13.773 15.75 13 15.75C10.6528 15.75 8.75 13.8472 8.75 11.5ZM13 8.75001C11.4812 8.75001 10.25 9.98122 10.25 11.5C10.25 13.0188 11.4812 14.25 13 14.25C14.5188 14.25 15.75 13.0188 15.75 11.5C15.75 9.98122 14.5188 8.75001 13 8.75001Z'
      fill='currentColor'
    />
  </Svg>
);

Docs20.displayName = 'Docs20';
export default Docs20;
